/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { Form, Typography, Select, Divider, InputNumber, Radio, Space, Button, message, Checkbox } from 'antd';
import emiter, { _EVENTS } from '../../../../events';
import { useCarModelPrice } from '../../../../hooks/product-price/car-model-price';
const { Title } = Typography;

interface PropsType {
	enums?: any;
	detail?: any;
	title?: any;
	disabled?: any;
}

const OtherRules: React.FC<PropsType> = props => {
	const { detail, title, disabled, enums } = props;

	const { queryRuleList, update } = useCarModelPrice();
	const selectStyle: React.CSSProperties = { width: '350px' };

	const [form] = Form.useForm();

	const [showBtn, setShowBtn] = useState(false);
	const [base, setBase] = useState([]);
	const [vip, setVip] = useState([]);
	const [vvip, setVvip] = useState([]);
	const [cancleRule, setCancleRule] = useState([]);
	const [serveRule, setServeRule] = useState([]);
	const [preRule, setPreRule] = useState([]);

	const mainFormFields = {
		jichubaozhang: {
			name: 'insurance_rule_basic_code',
			label: '基础保障',
			required: true,
			message: '请选择基础保障',
			placeholder: '请选择',
		},
		youxiangbaozhang: {
			name: 'insurance_rule_vip_code',
			label: '优享保障',
			required: true,
			message: '请选择优享保障',
			placeholder: '请选择',
		},
		zuxiangbaozhang: {
			name: 'insurance_rule_vvip_code',
			label: '尊享保障',
			required: true,
			message: '请选择尊享保障',
			placeholder: '请选择',
		},
		yudingguize: {
			name: 'pre_booking_rule_code',
			label: '预定规则',
			required: true,
			message: '请选择预定规则',
			placeholder: '请选择',
		},
		quxiaoguize: {
			name: 'cancel_rule_code',
			label: '取消规则',
			required: true,
			message: '请选择取消规则',
			placeholder: '请选择',
		},
		fuwuzhengce: {
			name: 'serve_rule_code',
			label: '服务政策',
			required: true,
			message: '请选择服务政策',
			placeholder: '请选择',
		},
		cheliangyajin: {
			name: 'deposit_broken',
			label: '车辆押金',
			required: true,
			message: '请输入车辆押金',
			placeholder: '请输入车辆押金',
		},
		weizhangyajin: {
			name: 'deposit_illegal',
			label: '违章押金',
			required: true,
			message: '请输入违章押金',
			placeholder: '请输入违章押金',
		},
		chexingbiaoqian: {
			name: 'tags',
			label: '车型标签',
			required: false,
			message: '请选择车型标签',
			placeholder: '请选择车型标签',
		},
	};

	// 删除尊享保障
	const hideBtn = () => {
		setShowBtn(true);
		form.setFieldsValue({ insurance_rule_vvip_code: undefined });
	};

	// 添加尊享保障
	const addVvip = () => {
		setShowBtn(false);
	};

	// 取消
	const cancelOperation = () => {
		emiter.emit(_EVENTS.PRODUCT_PRICE.CAR_MODEL_PRICE.CLOSE_DRAW);
	};

	const formatPrice = (price: any) => {
		if (!price) return price;
		if (!isNaN(Number(price))) {
			price = price * 100;
		}
		return price;
	};

	// 提交表单
	const submitForm = () => {
		form.validateFields().then(async (fieldsValue: any) => {
			const params = {
				...detail,
				...fieldsValue,
				car_age: fieldsValue.tags?.car_age ? fieldsValue.tags.car_age : undefined,
				tags:
					fieldsValue.tags?.car_tag && fieldsValue.tags?.car_tag.length
						? fieldsValue.tags.car_tag.join(',')
						: undefined,
				deposit_broken: formatPrice(fieldsValue.deposit_broken),
				deposit_illegal: formatPrice(fieldsValue.deposit_illegal),
			};
			const result: any = await update(params);
			if (result.errno === 0) {
				message.success('提交成功');
				cancelOperation();
			}
		});
	};

	// 查询各个规则模版
	const searchRule = async (params: any) => {
		const result = await queryRuleList(params);
		if (params.rule_type === 2) {
			if (params.level === 1) {
				setBase(result.data);
			} else if (params.level === 2) {
				setVip(result.data);
			} else if (params.level === 3) {
				setVvip(result.data);
			}
		} else if (params.rule_type === 3) {
			setCancleRule(result.data);
		} else if (params.rule_type === 4) {
			setServeRule(result.data);
		} else if (params.rule_type === 1) {
			setPreRule(result.data);
		}
	};

	// 更改价格显示
	const chengePriceFormat = (price: any) => {
		if (!price) return price;
		if (!isNaN(Number(price))) {
			price = price / 100;
		}
		return price;
	};

	const validatePrice = (rule: any, value: any) => {
		let labelStr = '';
		if (rule.field === 'deposit_broken') {
			labelStr = '车辆押金';
		} else if (rule.field === 'deposit_illegal') {
			labelStr = '违章押金';
		}
		if (!value) {
			return Promise.reject(new Error(`请输入${labelStr || '价格'}`));
		}
		if (value > 50000 || value < 1) {
			return Promise.reject(new Error('请输入1-50000的正整数'));
		}
		return Promise.resolve();
	};

	useEffect(() => {
		// rule_type 规则类型：1-预订规则, 2-增值服务规则, 3-取消规则，4-服务政策
		// level 保险政策: 1-基础保障, 2-优享保障, 3-尊享保障；只有增值服务时传值
		searchRule({ rule_type: 2, level: 1 });
		searchRule({ rule_type: 2, level: 2 });
		searchRule({ rule_type: 2, level: 3 });
		searchRule({ rule_type: 1 });
		searchRule({ rule_type: 3 });
		searchRule({ rule_type: 4 });
	}, []);

	useEffect(() => {
		if (detail) {
			const params: any = {
				insurance_rule_basic_code: detail.insurance_rule_basic_code || undefined,
				insurance_rule_vip_code: detail.insurance_rule_vip_code || undefined,
				insurance_rule_vvip_code: detail.insurance_rule_vvip_code || undefined,
				pre_booking_rule_code: detail.pre_booking_rule_code || undefined,
				cancel_rule_code: detail.cancel_rule_code || undefined,
				serve_rule_code: detail.serve_rule_code || undefined,
				deposit_broken: chengePriceFormat(detail.deposit_broken) || undefined,
				deposit_illegal: chengePriceFormat(detail.deposit_illegal) || undefined,
				tags: {},
			};
			if (detail.tags) {
				const tagList = detail.tags.split(',');
				params.tags.car_tag = tagList.map((item: any) => Number(item));
			}
			if (detail.car_age) {
				params.tags.car_age = detail.car_age;
			}
			if (params.insurance_rule_basic_code && !params.insurance_rule_vvip_code) {
				// 二次编辑后如果没有尊享保障直接不展示
				setShowBtn(true);
			}
			form.setFieldsValue(params);
		}
	}, [detail]);

	return (
		<>
			<Title level={5}>{title}</Title>
			<Divider />
			<Form form={form} wrapperCol={{ span: 10 }} disabled={disabled}>
				<Space align="baseline" size="large">
					<Form.Item
						label={mainFormFields.jichubaozhang.label}
						name={mainFormFields.jichubaozhang.name}
						wrapperCol={{ span: 24 }}
						rules={[
							{
								required: mainFormFields.jichubaozhang.required,
								message: mainFormFields.jichubaozhang.message,
							},
						]}
					>
						<Select
							style={selectStyle}
							placeholder={mainFormFields.jichubaozhang.placeholder}
							options={base}
							fieldNames={{ label: 'name', value: 'rule_code' }}
						/>
					</Form.Item>
					{!disabled && showBtn ? (
						<Button type="primary" onClick={addVvip}>
							添加尊享保障
						</Button>
					) : null}
				</Space>
				<Form.Item
					label={mainFormFields.youxiangbaozhang.label}
					name={mainFormFields.youxiangbaozhang.name}
					rules={[
						{
							required: mainFormFields.youxiangbaozhang.required,
							message: mainFormFields.youxiangbaozhang.message,
						},
					]}
				>
					<Select
						style={selectStyle}
						placeholder={mainFormFields.youxiangbaozhang.placeholder}
						options={vip}
						fieldNames={{ label: 'name', value: 'rule_code' }}
					/>
				</Form.Item>
				{!showBtn ? (
					<Space align="baseline" size="large">
						<Form.Item
							label={mainFormFields.zuxiangbaozhang.label}
							name={mainFormFields.zuxiangbaozhang.name}
							wrapperCol={{ span: 24 }}
							rules={[
								{
									required: mainFormFields.zuxiangbaozhang.required,
									message: mainFormFields.zuxiangbaozhang.message,
								},
							]}
						>
							<Select
								style={selectStyle}
								placeholder={mainFormFields.zuxiangbaozhang.placeholder}
								options={vvip}
								fieldNames={{ label: 'name', value: 'rule_code' }}
							/>
						</Form.Item>
						{!disabled ? (
							<Button type="primary" danger onClick={hideBtn}>
								删除
							</Button>
						) : null}
					</Space>
				) : null}
				<Form.Item
					label={mainFormFields.yudingguize.label}
					name={mainFormFields.yudingguize.name}
					rules={[
						{
							required: mainFormFields.yudingguize.required,
							message: mainFormFields.yudingguize.message,
						},
					]}
				>
					<Select
						style={selectStyle}
						placeholder={mainFormFields.yudingguize.placeholder}
						options={preRule}
						fieldNames={{ label: 'name', value: 'rule_code' }}
					/>
				</Form.Item>
				<Form.Item
					label={mainFormFields.quxiaoguize.label}
					name={mainFormFields.quxiaoguize.name}
					rules={[
						{
							required: mainFormFields.quxiaoguize.required,
							message: mainFormFields.quxiaoguize.message,
						},
					]}
				>
					<Select
						style={selectStyle}
						placeholder={mainFormFields.quxiaoguize.placeholder}
						options={cancleRule}
						fieldNames={{ label: 'name', value: 'rule_code' }}
					/>
				</Form.Item>
				<Form.Item
					label={mainFormFields.fuwuzhengce.label}
					name={mainFormFields.fuwuzhengce.name}
					rules={[
						{
							required: mainFormFields.fuwuzhengce.required,
							message: mainFormFields.fuwuzhengce.message,
						},
					]}
				>
					<Select
						style={selectStyle}
						placeholder={mainFormFields.fuwuzhengce.placeholder}
						options={serveRule}
						fieldNames={{ label: 'name', value: 'rule_code' }}
					/>
				</Form.Item>
				<Form.Item
					required
					label={mainFormFields.cheliangyajin.label}
					name={mainFormFields.cheliangyajin.name}
					rules={[
						{
							validator: validatePrice,
						},
					]}
				>
					<InputNumber
						placeholder={mainFormFields.cheliangyajin.placeholder}
						addonAfter="元"
						controls={false}
						precision={0}
					/>
				</Form.Item>
				<Form.Item
					required
					label={mainFormFields.weizhangyajin.label}
					name={mainFormFields.weizhangyajin.name}
					rules={[
						{
							validator: validatePrice,
						},
					]}
				>
					<InputNumber
						placeholder={mainFormFields.weizhangyajin.placeholder}
						addonAfter="元"
						controls={false}
						precision={0}
					/>
				</Form.Item>
				<Form.Item
					label={mainFormFields.chexingbiaoqian.label}
					name={mainFormFields.chexingbiaoqian.name}
					rules={[
						{
							required: mainFormFields.chexingbiaoqian.required,
							message: mainFormFields.chexingbiaoqian.message,
						},
					]}
				>
					<Space align="baseline">
						<Form.Item name={[mainFormFields.chexingbiaoqian.name, 'car_age']}>
							<Radio.Group>
								{enums?.car_age?.map((item: any) => (
									<Radio value={item.key} key={item.key}>
										{item.value}
									</Radio>
								))}
							</Radio.Group>
						</Form.Item>
					</Space>
					<Form.Item name={[mainFormFields.chexingbiaoqian.name, 'car_tag']}>
						<Checkbox.Group>
							{enums?.car_tag?.map((item: any) => (
								<Checkbox value={item.key} key={item.key} style={{ margin: '0 8px 0 0' }}>
									{item.value}
								</Checkbox>
							))}
						</Checkbox.Group>
					</Form.Item>
				</Form.Item>
			</Form>
			<div style={{ display: 'flex', justifyContent: 'center', marginTop: '50px' }}>
				<Space>
					<Button onClick={cancelOperation} disabled={disabled}>
						取消
					</Button>
					<Button type="primary" onClick={submitForm} disabled={disabled}>
						提交
					</Button>
				</Space>
			</div>
		</>
	);
};

export default OtherRules;
